import { Navigate } from "react-router-dom";
import { useRouteLocale } from "@/hooks/useRouteLocale";
import { USER_ROUTES } from "@/routes";

/**
 * The older payment settings URLs (/plati, /payments) redirect to the connected-accounts
 * page, the one payment settings page (JUB-198). `replace` keeps Back working.
 */
export function PaymentsRedirect() {
  const locale = useRouteLocale();
  return <Navigate to={USER_ROUTES.connectedAccounts(locale || "ro")} replace />;
}
